import { useEffect, useState } from "react";
import styled from "styled-components";

import $ from "jquery";
import {
  query,
  getDocs,
  doc,
  collection,
  setDoc,
  where,
  documentId,
  Timestamp,
  getDoc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../firebase.js";

import { EditorForm_quil as Quill } from "./editorForm_quil.js";
import { v4 as uuidv4 } from "uuid";
import { useLocation, useParams } from "react-router-dom";
import { GetAllData, GetLastDocId } from "../Api/callData.js";

window.$ = $;
window.jQuery = $;

// Firestore에서 특정 문서 가져오기(수정하기로 들어왔을때 사용)
export async function GetModifyTarget(data, field) {
  const dataRef = collection(db, data);
  const q = query(dataRef, where(documentId(), "==", field));
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map((doc) => ({
    id: doc.id,
    data: doc.data(),
  }));
}

/* ──────────────────────────────────────────────────────────────────────── */
const Page = styled.div`
  background: #ffffff;
  color: #0f172a;
  font-family: "Pretendard Variable", Pretendard, -apple-system,
    BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
`;

const Container = styled.div`
  max-width: 980px;
  margin: 0 auto;
  padding: 0 24px;
`;

const Hero = styled.section`
  margin-top: calc(-1 * clamp(60px, 10vw, 120px));
  padding: calc(clamp(96px, 12vw, 160px) + clamp(60px, 10vw, 120px)) 0
    clamp(32px, 4vw, 48px);
  text-align: center;
  background:
    radial-gradient(ellipse 70% 50% at 50% 0%, #eef2ff 0%, transparent 70%),
    #ffffff;
`;

const Eyebrow = styled.p`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #6366f1;
  margin: 0 0 12px;
`;

const HeroTitle = styled.h1`
  font-size: clamp(32px, 4.6vw, 56px);
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: -0.03em;
  color: #0f172a;
  margin: 0 0 12px;
`;

const HeroLead = styled.p`
  font-size: clamp(14.5px, 1.3vw, 16.5px);
  color: #64748b;
  margin: 0;
`;

/* ── Form ── */
const ContentSection = styled.section`
  padding: clamp(24px, 3vw, 40px) 0 clamp(80px, 10vw, 120px);
`;

const FormCard = styled.form`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 24px;
  padding: clamp(28px, 4vw, 44px);
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: ${(p) => p.$cols || "1fr"};
  gap: 16px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .label {
    font-size: 12.5px;
    font-weight: 600;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
`;

const baseInput = `
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
  font-size: 15px;
  color: #0f172a;
  font-family: inherit;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: #94a3b8;
  }
  &:focus {
    outline: 0;
    border-color: #c7d2fe;
    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.08);
  }
`;

const TextInput = styled.input`
  ${baseInput}
`;

const Select = styled.select`
  ${baseInput}
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%2364748b' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  padding-right: 40px;
`;

const EditorWrap = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;

  .ql-toolbar,
  .ql-container {
    border: 0;
  }
  .ql-toolbar {
    border-bottom: 1px solid #f1f5f9;
  }
  .ql-editor {
    min-height: 320px;
    font-family: inherit;
    font-size: 15px;
    line-height: 1.65;
  }
`;

const OptionBox = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 18px;
  padding: 16px 18px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;

  .label {
    font-size: 13px;
    font-weight: 600;
    color: #475569;
  }
  .opt {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #475569;
    cursor: pointer;
  }
  .opt input {
    accent-color: #6366f1;
  }
`;

const PasswordInput = styled.input`
  flex: 1;
  min-width: 140px;
  padding: 8px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  font-size: 14px;
  color: #0f172a;
  font-family: inherit;

  &:focus {
    outline: 0;
    border-color: #c7d2fe;
    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.08);
  }
  &:disabled {
    background: #f1f5f9;
    color: #94a3b8;
    cursor: not-allowed;
  }
`;

const DateInput = styled.input`
  ${baseInput}
  max-width: 220px;
`;

/* ── Thumbnail uploader ── */
const ThumbWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Dropzone = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  padding: 32px 20px;
  border: 1.5px dashed #cbd5e1;
  border-radius: 14px;
  background: #fafbff;
  color: #64748b;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;

  &:hover {
    border-color: #c7d2fe;
    background: #f5f3ff;
    color: #475569;
  }

  &.dragging {
    border-color: #6366f1;
    background: #eef2ff;
    color: #4338ca;
  }

  input {
    position: absolute;
    inset: 0;
    opacity: 0;
    cursor: pointer;
  }

  .hint {
    font-size: 12.5px;
    color: #94a3b8;
  }
`;

const ThumbPreview = styled.div`
  position: relative;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
  background: #f8fafc;

  img {
    display: block;
    width: 100%;
    max-height: 280px;
    object-fit: cover;
  }

  .remove {
    position: absolute;
    top: 10px;
    right: 10px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 999px;
    border: 0;
    background: rgba(15, 23, 42, 0.78);
    color: #ffffff;
    font-size: 12.5px;
    font-weight: 500;
    cursor: pointer;
    font-family: inherit;
    backdrop-filter: blur(6px);
    transition: background 0.15s ease;
  }
  .remove:hover {
    background: rgba(15, 23, 42, 0.92);
  }
`;

const OrUrl = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #94a3b8;

  .or {
    flex-shrink: 0;
  }
  input {
    flex: 1;
    padding: 10px 14px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    font-size: 14px;
    color: #0f172a;
    font-family: inherit;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }
  input::placeholder {
    color: #94a3b8;
  }
  input:focus {
    outline: 0;
    border-color: #c7d2fe;
    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.08);
  }
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
`;

const SubmitBtn = styled.button`
  padding: 12px 32px;
  border-radius: 999px;
  border: 0;
  background: linear-gradient(135deg, #6366f1 0%, #7c3aed 100%);
  color: #ffffff;
  font-size: 14.5px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  box-shadow: 0 8px 20px -10px rgba(99, 102, 241, 0.55);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 12px 28px -10px rgba(99, 102, 241, 0.7);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const MENU_OPTIONS = [
  { value: "inform", label: "Inform" },
  { value: "news", label: "News" },
  { value: "hiring", label: "Recruitment" },
  { value: "faq", label: "FAQ" },
  { value: "inquiry", label: "Inquiry" },
  { value: "popup", label: "Popup" },
];

export function AdminWrite() {
  const location = useLocation();
  const currnetPath = location.pathname;

  const [menu, setMenu] = useState(null);
  const [title, setTitle] = useState("");
  const [reg_time, setReg_time] = useState(new Date());
  const [content, setContent] = useState("");
  const [imageUrl, setImageUrl] = useState([]);
  const [secret, setSecret] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [tableLength, setTableLength] = useState(0);
  const [pw, setPw] = useState("");
  const [expireD, setExpireD] = useState(new Date());

  // Thumbnail (cover_img): either a File pending upload, or a string URL/path
  const [coverFile, setCoverFile] = useState(null);
  const [coverPreview, setCoverPreview] = useState("");
  const [coverUrl, setCoverUrl] = useState("");
  const [dragging, setDragging] = useState(false);

  const handleCoverFile = (file) => {
    if (!file) return;
    setCoverFile(file);
    setCoverUrl("");
    const reader = new FileReader();
    reader.onload = (e) => setCoverPreview(String(e.target.result || ""));
    reader.readAsDataURL(file);
  };

  const handleCoverUrlChange = (e) => {
    const value = e.target.value;
    setCoverUrl(value);
    if (value) {
      setCoverFile(null);
      setCoverPreview(value);
    } else if (!coverFile) {
      setCoverPreview("");
    }
  };

  const clearCover = () => {
    setCoverFile(null);
    setCoverUrl("");
    setCoverPreview("");
  };

  const { id } = useParams();

  const handleContentChange = (value) => setContent(value);

  const handleExpireSet = (event) => {
    const selectedDate = event.target.value;
    if (selectedDate) {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();
      const dateTime = new Date(
        `${selectedDate}T${hours}:${minutes}:${seconds}+09:00`
      );
      const timestamp = Timestamp.fromDate(dateTime);
      setExpireD(timestamp);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (currnetPath.indexOf(":") !== -1 && id) {
        const textPart = id.replace(/\d+/g, "").replace(":", "");
        const trueId = id.replace(":", "");
        const targetData = await GetModifyTarget(textPart, trueId);

        setMenu(textPart);
        setTitle(targetData[0].data.title);
        setReg_time(targetData[0].data.reg_time);
        setContent(targetData[0].data.content);

        const existingCover = targetData[0].data.cover_img;
        if (typeof existingCover === "string" && existingCover) {
          setCoverUrl(existingCover);
          setCoverPreview(existingCover);
        }

        const menuEl = document.querySelector("#menu");
        if (menuEl) menuEl.value = textPart;
        const titleEl = document.querySelector("#title");
        if (titleEl) titleEl.value = targetData[0].data.title;
        const editor = document.querySelector(".ql-editor.ql-blank");
        if (editor) editor.innerHTML = targetData[0].data.content;
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (menu) {
        const dataCount = await GetAllData(menu);
        setTableLength(dataCount);
      }
    };
    fetchData();
  }, [menu]);

  useEffect(() => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const images = doc.querySelectorAll("img");
    if (Array.from(images).length !== 0) {
      const extractUrl = Array.from(images).map((img) => img.src);
      setImageUrl(extractUrl);
    }
  }, [content]);

  const uploadImage = async (file) => {
    const dateFolder = new Date().toISOString().split("T")[0];
    const fileRef = ref(storage, `images/${dateFolder}/${file.name}`);
    await uploadBytes(fileRef, file);
    const downloadURL = await getDownloadURL(fileRef);
    return downloadURL;
  };

  const dataURLtoFile = (dataurl) => {
    if (!dataurl || !dataurl.startsWith("data:")) return null;
    const uniqueFileName = uuidv4() + ".jpg";
    const arr = dataurl.split(",");
    if (arr.length < 2) return null;
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], uniqueFileName, { type: mime });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitted(true);

    let thumnail_src = [];
    let uploadedUrls = [];

    if (id) {
      thumnail_src = imageUrl;
      const newImages = imageUrl.filter((url) => url.startsWith("data:"));
      if (newImages.length > 0) {
        uploadedUrls = await Promise.all(
          newImages.map(async (uploadedUrl) => {
            const file = dataURLtoFile(uploadedUrl);
            return await uploadImage(file);
          })
        );
        thumnail_src = uploadedUrls;
      }
    } else {
      const dataImages = imageUrl.filter((url) => url.startsWith("data:"));
      uploadedUrls = await Promise.all(
        dataImages.map(async (uploadedUrl) => {
          const file = dataURLtoFile(uploadedUrl);
          return await uploadImage(file);
        })
      );
      thumnail_src = uploadedUrls;
    }

    let imageIndex = 0;
    const changeContent = content.replace(
      /<img[^>]*src="([^"]*base64[^"]*)"/g,
      (match) => {
        if (imageIndex < uploadedUrls.length) {
          const newSrc = uploadedUrls[imageIndex++];
          return `<img src="${newSrc}" /`;
        }
        return match;
      }
    );

    // Cover thumbnail: upload File if any, else keep URL string
    let cover_img = "";
    if (coverFile) {
      try {
        cover_img = await uploadImage(coverFile);
      } catch (err) {
        console.error("커버 이미지 업로드 실패", err);
      }
    } else if (coverUrl && coverUrl.trim()) {
      cover_img = coverUrl.trim();
    }

    let content_txt = changeContent
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/&[a-zA-Z]{1,6};/g, "")
      .replace(/&#[0-9]{1,6};/g, "");

    let newItem = {};
    if (menu !== "inquiry" && menu !== "popup" && menu !== "hiring") {
      newItem = {
        title,
        content: changeContent,
        content_txt,
        reg_time,
        thumnail_img: thumnail_src,
        cover_img,
      };
    } else if (menu === "inquiry") {
      newItem = {
        title,
        content: changeContent,
        content_txt,
        userName: "관리자",
        reg_time,
        secret: pw,
        secret_check: secret,
      };
    } else if (menu === "popup") {
      newItem = {
        title,
        content: changeContent,
        content_txt,
        popup_yn: "Y",
        reg_time,
      };
    } else if (menu === "hiring") {
      newItem = {
        title,
        content: changeContent,
        content_txt,
        reg_time,
        expire_time: expireD,
        thumnail_img: thumnail_src,
        cover_img,
      };
    }

    setIsSubmitted(false);

    if (menu && menu.trim() !== "") {
      try {
        const lastDocId = await GetLastDocId(menu);
        let uniqueId;

        if (lastDocId) {
          const match = lastDocId.match(/([a-zA-Z]+)(\d+)/);
          if (match) {
            uniqueId = match[1] + (parseInt(match[2], 10) + 1);
          } else {
            console.error("lastDocId 형식이 예상과 다릅니다.");
          }
        } else {
          uniqueId = menu + "1";
        }

        if (id) {
          uniqueId = id.replace(":", "");
        }

        if (menu === "popup") {
          const countRef = doc(db, "popupCount", "popupCount1");
          const countSnap = await getDoc(countRef);
          if (!countSnap.exists()) {
            try {
              await setDoc(countRef, { count: 1 });
            } catch (error) {
              console.error("popupCount 추가 중 오류발생: ", error);
            }
          }
        }

        await setDoc(doc(collection(db, menu), uniqueId), newItem);
        alert("Post has been registered.");
        window.history.back();
      } catch (error) {
        console.error("등록 오류", error);
      }
    } else {
      alert("Menu values have not been set. Please select a menu.");
    }
  };

  const isEdit = !!id;

  return (
    <Page>
      <Hero>
        <Container>
          <Eyebrow>Admin</Eyebrow>
          <HeroTitle>{isEdit ? "Edit post" : "Write a post"}</HeroTitle>
          <HeroLead>
            {isEdit
              ? "Update the post content and save your changes."
              : "Create a new post for Inform / News / Recruitment / FAQ / Inquiry / Popup."}
          </HeroLead>
        </Container>
      </Hero>

      <ContentSection>
        <Container>
          <FormCard id="boardForm" onSubmit={handleSubmit}>
            <Row $cols="200px 1fr">
              <Field>
                <span className="label">Category</span>
                <Select
                  id="menu"
                  value={menu || ""}
                  onChange={(e) => setMenu(e.target.value)}
                  disabled={isEdit}
                >
                  <option value="" disabled>
                    Select…
                  </option>
                  {MENU_OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>
                      {o.label}
                    </option>
                  ))}
                </Select>
                {tableLength > 0 && (
                  <span style={{ fontSize: 12, color: "#94a3b8" }}>
                    {tableLength} existing post{tableLength === 1 ? "" : "s"}
                  </span>
                )}
              </Field>
              <Field>
                <span className="label">Title</span>
                <TextInput
                  id="title"
                  type="text"
                  placeholder="Post title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Field>
            </Row>

            {menu !== "inquiry" && menu !== "popup" && (
              <Field>
                <span className="label">Thumbnail</span>
                <ThumbWrap>
                  {coverPreview ? (
                    <ThumbPreview>
                      <img src={coverPreview} alt="thumbnail preview" />
                      <button
                        type="button"
                        className="remove"
                        onClick={clearCover}
                      >
                        ✕ Remove
                      </button>
                    </ThumbPreview>
                  ) : (
                    <Dropzone
                      className={dragging ? "dragging" : ""}
                      onDragOver={(e) => {
                        e.preventDefault();
                        setDragging(true);
                      }}
                      onDragLeave={() => setDragging(false)}
                      onDrop={(e) => {
                        e.preventDefault();
                        setDragging(false);
                        const file = e.dataTransfer?.files?.[0];
                        if (file && file.type.startsWith("image/")) {
                          handleCoverFile(file);
                        }
                      }}
                    >
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleCoverFile(e.target.files?.[0])}
                      />
                      <strong>Click or drop image to upload</strong>
                      <span className="hint">
                        PNG, JPG, WebP. Stored in Firebase Storage.
                      </span>
                    </Dropzone>
                  )}
                  <OrUrl>
                    <span className="or">or paste URL / path</span>
                    <input
                      type="text"
                      placeholder="/images/playground9.png or https://..."
                      value={coverUrl}
                      onChange={handleCoverUrlChange}
                    />
                  </OrUrl>
                </ThumbWrap>
              </Field>
            )}

            <Field>
              <span className="label">Content</span>
              <EditorWrap>
                <Quill onChange={handleContentChange} />
              </EditorWrap>
            </Field>

            {menu === "inquiry" && (
              <Field>
                <span className="label">Privacy</span>
                <OptionBox>
                  <span className="label">Visibility</span>
                  <label className="opt" htmlFor="visPublic">
                    <input
                      id="visPublic"
                      type="radio"
                      name="secret"
                      onChange={() => setSecret(false)}
                      checked={secret === false}
                    />
                    Public
                  </label>
                  <label className="opt" htmlFor="visPrivate">
                    <input
                      id="visPrivate"
                      type="radio"
                      name="secret"
                      onChange={() => setSecret(true)}
                      checked={secret === true}
                    />
                    Private
                  </label>
                  <PasswordInput
                    type="password"
                    placeholder="Set a password"
                    disabled={!secret}
                    value={pw}
                    onChange={(e) => setPw(e.target.value)}
                  />
                </OptionBox>
              </Field>
            )}

            {menu === "hiring" && (
              <Field>
                <span className="label">Application deadline</span>
                <DateInput type="date" onChange={handleExpireSet} />
              </Field>
            )}

            <Actions>
              <SubmitBtn type="submit" disabled={isSubmitted}>
                {isEdit ? "Save changes" : "Publish post"}
              </SubmitBtn>
            </Actions>
          </FormCard>
        </Container>
      </ContentSection>
    </Page>
  );
}
